import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h16v16H0z"
}), React.createElement("path", {
  d: "M8.153 1c.815 0 1.46.142 2.04.452a3.271 3.271 0 011.355 1.355c.31.58.452 1.225.452 2.04V7h.218c.446 0 .607.046.77.134a.906.906 0 01.378.378c.088.163.134.324.134.77v5.436c0 .446-.046.607-.134.77a.909.909 0 01-.378.378c-.163.088-.324.134-.77.134H3.782c-.446 0-.607-.046-.77-.134a.909.909 0 01-.378-.378c-.088-.163-.134-.324-.134-.77V8.282c0-.446.046-.607.134-.77a.909.909 0 01.378-.378c.163-.088.324-.134.77-.134H4V4.847c0-.815.142-1.46.452-2.04a3.271 3.271 0 011.355-1.355C6.387 1.142 7.032 1 7.847 1h.306zm0 2h-.306c-.503 0-.826.071-1.096.216-.234.124-.41.301-.535.535C6.07 4.02 6 4.344 6 4.847V7h4V4.847c0-.503-.071-.826-.216-1.096a1.272 1.272 0 00-.535-.535C8.98 3.07 8.656 3 8.153 3z",
  fill: "#262626"
}));

var SvgLockSmall = function SvgLockSmall(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgLockSmall;